import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';

import { toggleMoreModal } from '../../Modal/actions';

@translate(['header'], { wait: true })
@onClickOutside
class Support extends Component {
  constructor(props) {
    super(props);

    this.state = {
      moreOpened: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(e) {
    e.preventDefault();
    this.setState({
      moreOpened: false,
    });
    this.props.toggleModal();
  }

  handleClickOutside() {
    this.setState({
      moreOpened: false,
    });
  }

  render() {
    const { t } = this.props;
    return (<a onClick={this.toggleModal} href="">{t('header:support')}</a>);
  }
}

Support.WrappedComponent.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(
  () => ({}),
  dispatch => ({
    toggleModal() {
      dispatch(toggleMoreModal());
    },
  }),
)(Support);



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarFooter/Support.js